import React from "react";
import { userPath } from "../helpers/slug";

// Author shown for work whose account was deleted. Not a real account, so it isn't a link.
export const DELETED_USER = "deleted";

// "@name" that is a real link (/user/name) but opens the in-app profile panel on a plain click.
export default function UserLink({ username, onOpen, className }) {
  if (username === DELETED_USER) return <span className="user-deleted">{DELETED_USER}</span>;
  return (
    <a
      href={userPath(username)}
      className={className || "user-link"}
      onClick={(e) => {
        if (!onOpen || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return; // let "open in new tab" work
        e.preventDefault();
        onOpen(username);
      }}
    >
      @{username}
    </a>
  );
}
